const carouselItems = [
  {
    title: '2026娱乐圈婚变潮：五位顶流艺人婚姻状况深度对比',
    desc: '从甜蜜官宣到黯然分手，2026年上半年娱乐圈迎来了前所未有的婚变潮。本文横向对比五位顶流艺人的婚姻轨迹...',
    tag: '年度策划',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20wedding%20ring%20on%20dark%20velvet%20surface%20with%20dramatic%20side%20lighting%2C%20cracked%20mirror%20reflection%2C%20warm%20dark%20red%20and%20gold%20tones%2C%20editorial%20magazine%20spread%20style%2C%20luxurious%20and%20melancholic%20atmosphere%2C%20cinematic%20composition&width=700&height=450&seq=carousel-01-2026&orientation=landscape',
  },
  {
    title: '选秀十年黑幕史：从超女到创造营，那些年被掩盖的真相',
    desc: '选秀节目在中国已走过十余年历程。然而光鲜舞台背后，暗藏着一条令人震惊的灰色利益链...',
    tag: '深度调查',
    imageUrl: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20spotlights%20and%20smoke%20machine%20effects%2C%20empty%20audience%20seats%2C%20warm%20golden%20stage%20lighting%2C%20behind%20the%20scenes%20vibe%2C%20editorial%20documentary%20style%2C%20contrast%20between%20bright%20stage%20and%20dark%20backstage&width=700&height=450&seq=carousel-02-2026&orientation=landscape',
  },
  {
    title: '顶流塌房经济学：一个人设崩塌背后损失多少个亿？',
    desc: '当一位顶流艺人人设崩塌，受损的不仅是个人声誉。品牌解约、影视项目搁浅、粉丝流失...连锁反应带来的经济损失令人咋舌。',
    tag: '数据分析',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20data%20visualization%20with%20falling%20red%20graphs%20and%20charts%2C%20dark%20trading%20floor%20atmosphere%2C%20dramatic%20red%20and%20dark%20tones%2C%20stock%20market%20crash%20metaphor%2C%20editorial%20business%20magazine%20style%2C%20cinematic%20lighting&width=700&height=450&seq=carousel-03-2026&orientation=landscape',
  },
  {
    title: '娱乐圈"潜规则"全图谱：从剧组到综艺的利益输送网络',
    desc: '一位匿名的圈内资深人士，首次向我们完整描绘了娱乐圈内部盘根错节的利益关系网...',
    tag: '独家揭秘',
    imageUrl: 'https://readdy.ai/api/search-image?query=Complex%20network%20diagram%20with%20interconnected%20nodes%20and%20lines%20in%20dark%20red%20and%20warm%20gold%2C%20abstract%20data%20visualization%2C%20mysterious%20noir%20atmosphere%2C%20investigative%20journalism%20aesthetic%2C%20dramatic%20lighting%2C%20cinematic%20composition&width=700&height=450&seq=carousel-04-2026&orientation=landscape',
  },
  {
    title: '从流量到实力：那些靠炒作起家的艺人如今怎么样了？',
    desc: '流量时代催生了无数靠话题和炒作上位的艺人。当初红极一时，如今有人销声匿迹、有人成功转型...',
    tag: '人物特写',
    imageUrl: 'https://readdy.ai/api/search-image?query=Silhouetted%20figure%20standing%20on%20empty%20theater%20stage%20under%20single%20dramatic%20spotlight%2C%20dust%20particles%20in%20light%20beam%2C%20warm%20golden%20light%2C%20melancholic%20atmosphere%2C%20editorial%20portrait%20style%2C%20cinematic%20composition%2C%20contemplative%20mood&width=700&height=450&seq=carousel-05-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            编辑精选的深度专题报道，带你以更高视角看清娱乐圈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.slice(0, 2).map((item, i) => (
            <article key={i} className="lg:col-span-1 group bg-background-50 rounded-lg overflow-hidden cursor-pointer">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-1 bg-accent-500 text-accent-950 text-[10px] font-semibold rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors mb-3">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
          {carouselItems.slice(2).map((item, i) => (
            <article key={i + 2} className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-1 bg-accent-500 text-accent-950 text-[10px] font-semibold rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors mb-3">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}